<template>
	<div class="form-group" autocomplete="off" :class="{ 'has-error': hasError }">
		<input
			ref="input"
			v-model="val"
			class="pin-code-input"
			:class="{ empty: value.length === 0 }"
			:placeholder="Array(length + 1).join('0')"
			:maxlength="length"
			:disabled="disabled"
			@input="updateValue($event.target.value)"
		/>
		<p v-show="hasError" class="help-block">{{ $t(errorText) }}</p>
	</div>
</template>

<script>
export default {
	name: 'PinCodeInput',
	props: {
		value: {
			type: String,
			default: '',
		},
		hasError: {
			type: Boolean,
			default: false,
			note: 'Show error text',
		},
		errorText: {
			type: String,
			default: '',
			note: 'Input error text or i18n key',
		},
		length: {
			type: Number,
			default: 6,
			note: 'Input auto code length',
		},
		autofocus: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			val: '',
		};
	},
	watch: {
		value: {
			handler(val = '') {
				if (val !== this.val) {
					this.updateValue(val);
				}
			},
			immediate: true,
		},
	},
	mounted() {
		if (this.autofocus) this.$refs.input.focus();
	},
	methods: {
		updateValue(val) {
			const value = val
				.toString()
				.replace(/[\W]/g, '')
				.substr(0, this.length);
			this.val = value;
			this.$emit('input', value);
			if (value.length === this.length) {
				this.$emit('fulfill');
			}
		},
	},
};
</script>

<style lang="scss">
.pin-code-input {
	width: 100%;
	height: 50px;
	font-size: 24px;
	text-indent: 20px;
	letter-spacing: 20px;
	color: #d9d9d9;
	text-align: center;
	background: black;
	border: 1px solid rgba(255, 255, 255, 0.25);
	border-radius: 3px;
	outline: none !important;
	text-transform: uppercase;

	&:focus,
	&:active {
		color: white;
	}
	&:focus {
		border-color: hsla(0, 0%, 100%, 0.5);
		box-shadow: 0px 0px 10px rgba(#000, 0.3);
	}
	&.empty {
		caret-color: transparent; // hide cursor
	}
}
.has-error {
	input {
		border: 2px solid #e63f57;
	}
}
</style>
